function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(0.25 2.04)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 206.76,
  cy: 144.05,
  r: 61.84,
  fill: "none"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradientb",
  x1: 206.76,
  y1: 210.08,
  x2: 206.76,
  y2: 118.07,
  gradientTransform: "translate(-21.74 40.38) rotate(-10.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5356a5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#4e5199"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#40427a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#2a2b48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#202031"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "price-outer-circle"
}, /*#__PURE__*/React.createElement("line", {
  x1: 207.09,
  y1: 146.11,
  x2: 785.61,
  y2: 248.11,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.18,
  y1: 146.13,
  x2: 578.68,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.26,
  y1: 146.16,
  x2: 441.39,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.33,
  y1: 146.21,
  x2: 368.37,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.39,
  y1: 146.28,
  x2: 320.72,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.44,
  y1: 146.35,
  x2: 285.38,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.48,
  y1: 146.43,
  x2: 256.58,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.5,
  y1: 146.51,
  x2: 231.27,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.51,
  y1: 146.6,
  x2: 207.51,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.5,
  y1: 146.68,
  x2: 183.75,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.48,
  y1: 146.77,
  x2: 158.49,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.44,
  y1: 146.85,
  x2: 129.79,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.39,
  y1: 146.92,
  x2: 94.59,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.33,
  y1: 146.98,
  x2: 47.2,
  y2: 281.34,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.26,
  y1: 147.03,
  x2: 0.25,
  y2: 266.55,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.18,
  y1: 147.07,
  x2: 0.25,
  y2: 222.38,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.09,
  y1: 147.09,
  x2: 0.25,
  y2: 183.56,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 147.1,
  x2: 0.25,
  y2: 147.1,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 147.09,
  x2: 0.25,
  y2: 110.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.83,
  y1: 147.07,
  x2: 0.25,
  y2: 71.88,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.76,
  y1: 147.03,
  x2: 0.25,
  y2: 27.81,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.68,
  y1: 146.98,
  x2: 35.87,
  y2: 3.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.62,
  y1: 146.92,
  x2: 86.57,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.57,
  y1: 146.85,
  x2: 124.01,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.54,
  y1: 146.77,
  x2: 153.18,
  y2: 0.17,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.51,
  y1: 146.68,
  x2: 181.33,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.51,
  y1: 146.6,
  x2: 206.51,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.51,
  y1: 146.51,
  x2: 231.67,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.54,
  y1: 146.43,
  x2: 258.5,
  y2: 3.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.57,
  y1: 146.35,
  x2: 288.85,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.62,
  y1: 146.28,
  x2: 326.14,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.68,
  y1: 146.21,
  x2: 378.5,
  y2: 2.04,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.76,
  y1: 146.16,
  x2: 453.26,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.83,
  y1: 146.13,
  x2: 597.76,
  y2: 3.84,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 146.11,
  x2: 768.25,
  y2: 47.13,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.1,
  x2: 768.25,
  y2: 146.1,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 206.98,
  y1: 146.54,
  x2: 268.89,
  y2: 151.96,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.98,
  y1: 146.55,
  x2: 267.02,
  y2: 162.63,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.99,
  y1: 146.55,
  x2: 263.32,
  y2: 172.82,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207,
  y1: 146.56,
  x2: 257.91,
  y2: 182.21,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207,
  y1: 146.57,
  x2: 250.95,
  y2: 190.51,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.57,
  x2: 242.66,
  y2: 197.48,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.58,
  x2: 233.28,
  y2: 202.91,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.59,
  x2: 223.1,
  y2: 206.62,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.6,
  x2: 212.43,
  y2: 208.51,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.61,
  x2: 201.6,
  y2: 208.52,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207.01,
  y1: 146.62,
  x2: 190.92,
  y2: 206.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207,
  y1: 146.63,
  x2: 180.74,
  y2: 202.95,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 207,
  y1: 146.63,
  x2: 171.35,
  y2: 197.54,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.99,
  y1: 146.64,
  x2: 163.04,
  y2: 190.59,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.98,
  y1: 146.64,
  x2: 156.07,
  y2: 182.29,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.98,
  y1: 146.65,
  x2: 150.65,
  y2: 172.91,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.97,
  y1: 146.65,
  x2: 146.93,
  y2: 162.73,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.96,
  y1: 146.65,
  x2: 145.04,
  y2: 152.07,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.95,
  y1: 146.65,
  x2: 145.03,
  y2: 141.23,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.94,
  y1: 146.64,
  x2: 146.91,
  y2: 130.56,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.93,
  y1: 146.64,
  x2: 150.6,
  y2: 120.37,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 146.63,
  x2: 156.01,
  y2: 110.99,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 146.63,
  x2: 162.97,
  y2: 102.68,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.62,
  x2: 171.27,
  y2: 95.71,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.61,
  x2: 180.64,
  y2: 90.28,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.6,
  x2: 190.82,
  y2: 86.57,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.59,
  x2: 201.49,
  y2: 84.68,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.58,
  x2: 212.33,
  y2: 84.67,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.91,
  y1: 146.57,
  x2: 223,
  y2: 86.54,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 146.57,
  x2: 233.18,
  y2: 90.24,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.92,
  y1: 146.56,
  x2: 242.57,
  y2: 95.65,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.93,
  y1: 146.55,
  x2: 250.88,
  y2: 102.61,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.94,
  y1: 146.55,
  x2: 257.85,
  y2: 110.9,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.95,
  y1: 146.54,
  x2: 263.28,
  y2: 120.28,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.96,
  y1: 146.54,
  x2: 266.99,
  y2: 130.46,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 206.97,
  y1: 146.54,
  x2: 268.88,
  y2: 141.13,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "price-dark-dot",
  cx: 207.01,
  cy: 146.1,
  r: 46.15,
  fill: "#202031"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "price-commas"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "220.29 146.08 193.72 146.11 206.95 93.74 220.29 146.08",
  fill: "#5356a5"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "193.72 146.11 207.06 198.45 220.29 146.08 193.72 146.11",
  fill: "url(#linear-gradientb)"
}));

function SvgAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "price-animation",
    viewBox: "0 0 785.69 281.81",
    width: 785.69,
    height: 281.81
  }, props), _ref, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "price-inner-circle"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _ref3)), _ref4, _ref5);
}

export default "data:image/svg+xml;base64,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";
export { SvgAnimation as ReactComponent };